// ボスの模型（影絵の関節模型）の入口。技を足す時は moves/ に1本書いてここへ並べる。
//   作り方＝docs/boss-production-map.md 駅1。ラボ＝boss-mockup-lab.html。

import type { MockupMove } from './core'
import { BLADE_QUICK_ALT_MOCKUP } from './moves/blade_quick_alt'
import { BLADE_QUICK_BODY_MOCKUPS } from './moves/blade_quick_body'
import { BLADE_QUICK_DANCE_MOCKUP } from './moves/blade_quick_dance'
import { BLADE_QUICK_CROSS_MOTION, BLADE_QUICK_CROSS_MOTION_A } from './moves/blade_quick_cross_motion'
import { ROOSTER_TOKI_MOCKUP } from './moves/rooster_toki'
import { HOUND_WALK_LONG_MOCKUP, HOUND_WALK_REAL_MOCKUP, HOUND_WALK_REAL_SLOW_MOCKUP, HOUND_WALK_SHORT_MOCKUP } from './moves/hound_walk'
import { LUNA_EXEC_MOCKUPS } from './moves/luna_execute'
import { PRINCESS_COUNT_JAB_MOCKUP } from './moves/princess_count_jab'
import { PRINCESS_TELL_MOCKUPS } from './moves/princess_count_tells'
import { PRINCESS_LIGHT_MOCKUPS } from './moves/princess_stage_lights'
import { PRINCESS_BATTLE_MOCKUPS } from './moves/princess_light_battle'
import { PRINCESS_RING_MOCKUPS } from './moves/princess_ring_count'
import { PRINCESS_OWN_MOCKUPS } from './moves/princess_own_moves'

export * from './core'
export { MOCKUP_BODIES, MOCKUP_COLORS } from './body'
export { drawMockupFrame, downedPoint } from './render'
export { twinsDownScene, twinsCollapseScene, drawTwinsScene } from './twins_scene'

export const MOCKUP_MOVES: MockupMove[] = [BLADE_QUICK_CROSS_MOTION, BLADE_QUICK_CROSS_MOTION_A, BLADE_QUICK_DANCE_MOCKUP, ...BLADE_QUICK_BODY_MOCKUPS, BLADE_QUICK_ALT_MOCKUP, ROOSTER_TOKI_MOCKUP, HOUND_WALK_REAL_MOCKUP, HOUND_WALK_REAL_SLOW_MOCKUP, HOUND_WALK_LONG_MOCKUP, HOUND_WALK_SHORT_MOCKUP, ...LUNA_EXEC_MOCKUPS, PRINCESS_COUNT_JAB_MOCKUP, ...PRINCESS_TELL_MOCKUPS, ...PRINCESS_LIGHT_MOCKUPS, ...PRINCESS_BATTLE_MOCKUPS, ...PRINCESS_RING_MOCKUPS, ...PRINCESS_OWN_MOCKUPS]
